export const NAME = 'profile'

export default { NAME }
